<template>
    <v-container>
        <v-card v-show="myInfo.role == 'mgr'">
            <!-- =========================== -->
            <v-toolbar color="indigo" dark>
                <v-toolbar-title>
                    <h3>管理者メニュー</h3>
                </v-toolbar-title>
            </v-toolbar>
            <!-- =========================== -->
            <v-card-text>
                <v-btn to="/sites" color="primary" block class="my-5 pa-9">
                    <h2>サイト設定</h2>
                </v-btn>
                <v-btn to="/devices" color="primary" block class="my-5 pa-9">
                    <h2>イケス設定</h2>
                </v-btn>
                <v-btn to="/feeders" color="primary" block class="my-5 pa-9">
                    <h2>給餌機設定</h2>
                </v-btn>
                <v-btn to="/sensors" color="primary" block class="my-5 pa-9">
                    <h2>環境センサー設定</h2>
                </v-btn>
                <v-btn to="/cameras" color="primary" block class="my-5 pa-9">
                    <h2>カメラ設定</h2>
                </v-btn>
                <v-btn to="/users" color="primary" block class="my-5 pa-9">
                    <h2>ユーザ設定</h2>
                </v-btn>
            </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card class="mt-10">
            <!-- =========================== -->
            <v-toolbar color="indigo" dark>
                <v-toolbar-title>
                    <h3 class="text-center">個別メニュー</h3>
                </v-toolbar-title>
            </v-toolbar>
            <!-- =========================== -->
            <v-card-text>
                <v-btn to="/chart-setting" color="primary" block class="my-5 pa-9">
                    <h2>グラフ設定</h2>
                </v-btn>
                <v-btn to="/notification-configs" color="primary" block class="my-5 pa-9">
                    <h2>通知設定</h2>
                </v-btn>
                <v-btn to="/logout" color="warning" block class="my-5 pa-9">
                    <h2>ログアウト</h2>
                </v-btn>
            </v-card-text>
            <!-- =========================== -->
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "Settings",
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbSites: [],
            dbUsers: [],
        };
    },
    //#######################################################
    created: async function () {
        //====================================================
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //---------------------------
        //this.getSites();
        //this.getUsers();
        this.putUserOperated();
        //---------------------------
        window.scrollTo(0, 0);
    },
    //#######################################################
    methods: {
        //====================================================
        async getSites() {
            await this.axios({
                method: "GET",
                url: "/web/api/sites",
                //params: { "_order[sort_no]": "desc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSites = response.data.json;
            });
        },
        //====================================================
        async getUsers() {
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                //params: { "_order[sort_no]": "desc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbUsers = response.data.json;
                if (this.dbUsers[0]) {
                    if (this.dbUsers[0].line_notify_token) this.dispLineNotify = true;
                }
            });
        },
        //====================================================
        putUserOperated() {
            this.axios({
                method: "PUT",
                url: "/web/api/user_operated",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            });
        },
        //====================================================
    },
    //#######################################################
};
</script>
